<template>
  <help-dialog title="Tags" maxWidth="700px" :includeMargin="false">
    <template #activator="{ openDialog }">
      <v-btn
        size="small"
        variant="text"
        icon="mds:help"
        @click="openDialog"
        style="font-size: 20px;"
      />
    </template>
    <template #default>
      <h3 class="mb-2 text-black">
        What Are Tags?
      </h3>
      <p class="text-grey-darken-3">
        <b>Tags</b> are short labels attached to <b>domain events</b> through a
        special kind of card. They give you a lightweight way to categorize work
        across the diagram &mdash; for example, by team, by priority, by theme,
        or by any other dimension that is useful to you.
      </p>

      <br/><br/>

      <h3 class="mb-2 text-black">
        How Tags Are Added
      </h3>
      <p class="text-grey-darken-3">
        Tags are only carried by cards whose card type has the <b>Tag</b> domain
        model role. To enable tags in a workflow:
      </p>
      <br/>
      <ul class="ml-5">
        <li>
          Open <b>Card Type Settings</b> and create (or pick) a card type whose
          <i>Domain Model Role</i> is set to <i>Tag</i>.
        </li>
        <li>
          On a domain event, add a card of that tag card type. Instead of a
          free-text field, it shows a tag picker where you can type new tags or
          choose from tags already used elsewhere in the workflow.
        </li>
        <li>
          Every value you enter on that card becomes part of the workflow's tag
          set and shows up in this tab.
        </li>
      </ul>

      <br/><br/>

      <h3 class="mb-2 text-black">
        What Tags Are Used For
      </h3>
      <ul class="ml-5">
        <li>
          <b>Filtering the diagram and backlog:</b>&nbsp;Use the tag filter in
          the top navigation to show only the domain events whose cards carry a
          given tag. Counts shown next to each tag are the number of domain
          events that match.
        </li>
        <li>
          <b>Categorizing work:</b>&nbsp;Group related domain events by theme,
          team, or status without changing the underlying card types.
        </li>
        <li>
          <b>Narrowing exports:</b>&nbsp;When a tag filter is active, CSV
          exports honor it and only include cards from the matching domain
          events.
        </li>
      </ul>

      <br/><br/>

      <h3 class="mb-2 text-black">
        What This Tab Does
      </h3>
      <p class="text-grey-darken-3">
        This tab gives you a workflow-wide view of every tag in use, together
        with how many cards each tag is attached to. From here you can:
      </p>
      <br/>
      <ul class="ml-5">
        <li><b>Search:</b>&nbsp;Find a specific tag by name.</li>
        <li>
          <b>Review usage:</b>&nbsp;See how many cards reference each tag, so
          you can spot duplicates, typos, or tags that are no longer relevant.
        </li>
        <li>
          <b>Delete a tag:</b>&nbsp;Remove a tag from every card in the workflow
          in one step. Useful for retiring a temporary label or cleaning up
          duplicates. Deletion cannot be undone.
        </li>
      </ul>

      <br/><br/>

      <h3 class="mb-2 text-black">
        Tips
      </h3>
      <ul class="ml-5">
        <li>
          <b>Reuse existing tags:</b>&nbsp;Pick from the suggestions rather than
          retyping, so filters stay clean and consistent.
        </li>
        <li>
          <b>Keep tags short:</b>&nbsp;A few well-chosen labels are easier to
          filter on than many one-off ones.
        </li>
        <li>
          <b>Clean up regularly:</b>&nbsp;Use this tab to delete tags that have
          served their purpose.
        </li>
      </ul>
    </template>
  </help-dialog>
</template>

<script setup>
import HelpDialog from '@/components/HelpDialog.vue'
</script>
